import type { CartExperimentState } from '@/types/cart-experiment';
import { getCartExperimentPolicy, getCartSitePolicy } from '@/domain/cart/experiment';
import { CART_POPOVER_EXPERIMENT_OVERRIDE } from '@/domain/cart/experiment/config';

/** 浮窗固定策略优先；取消固定后沿用原站点分流，保留所有样式实现。 */
export function getCartSidebarPresentation(
  pathname: string,
  isMobile: boolean,
  experiment: CartExperimentState,
  site = 'us',
): 'legacy' | 'v1' {
  const policy =
    CART_POPOVER_EXPERIMENT_OVERRIDE === null
      ? getCartSitePolicy(site, experiment)
      : getCartExperimentPolicy(CART_POPOVER_EXPERIMENT_OVERRIDE);
  return !isMobile && pathname !== '/cart' && policy.experience === 'v1' ? 'v1' : 'legacy';
}
